// Shared browser-download helpers used by both country exporters.

export function triggerDownload(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.click();
  URL.revokeObjectURL(url);
}

export function today() {
  return new Date().toISOString().slice(0, 10);
}
